import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StockAdjustDialog = ({
  open,
  onOpenChange,
  selectedTool,
  stockAdjustment,
  setStockAdjustment,
  onAdjust
}) => {
  if (!selectedTool) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">Ajuster le Stock</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="p-4 bg-muted rounded-lg space-y-2">
            <p className="font-heading font-medium">{selectedTool.name}</p>
            <div className="flex gap-4 text-sm">
              <span>Stock total: <Badge variant="outline">{selectedTool.quantity_total}</Badge></span>
              <span>Disponibles: <Badge variant="default" className="bg-chart-3">{selectedTool.quantity_available}</Badge></span>
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="adjustment">Ajustement (+/-)</Label>
            <Input
              id="adjustment"
              data-testid="stock-adjustment-input"
              type="number"
              value={stockAdjustment}
              onChange={(e) => setStockAdjustment(e.target.value)}
              placeholder="Ex: +5 ou -2"
              className="rounded-lg"
            />
            <p className="text-xs text-muted-foreground">
              Entrez un nombre positif pour ajouter au stock ou négatif pour retirer
            </p>
          </div>

          <div className="flex gap-2">
            <Button
              data-testid="stock-add-button"
              onClick={() => onAdjust(Math.abs(parseInt(stockAdjustment) || 0))}
              disabled={!stockAdjustment || parseInt(stockAdjustment) === 0}
              variant="default"
              className="flex-1 rounded-full"
            >
              <TrendingUp className="w-4 h-4 mr-2" />
              Ajouter
            </Button>
            <Button
              data-testid="stock-remove-button"
              onClick={() => onAdjust(-Math.abs(parseInt(stockAdjustment) || 0))}
              disabled={!stockAdjustment || parseInt(stockAdjustment) === 0}
              variant="destructive"
              className="flex-1 rounded-full"
            >
              <TrendingDown className="w-4 h-4 mr-2" />
              Retirer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StockAdjustDialog;
